import { getData, postData } from '@/views/mped/services/mped-service';
import { getCookie } from '@/utils/cookies';

export const getUploadedSapData = async (args) => {
  const url = args.processGuid && 'analysis/total/detail' || 'upload/view';

  return getData({
    url: `/calculation/${url}`,
    uuid: 'e2213f8b-88a7-4238-9ede-e074e04d0202',
    args: {
      appId: getCookie('app'),
      ...args,
    },
    fullResponse: true
  });
};

export const getUploadedHistorySapData = async (args) => {
  return getData({
    url: '/calculation/upload/history',
    uuid: 'a576108b-193d-46e0-ab31-2209afb8e1ae',
    args: {
      appId: getCookie('app'),
      ...args,
    },
    fullResponse: true
  });
};

export const postCalculationRow = async (args) => {
  return postData({
    url: '/calculation/upload/view',
    uuid: '51287f10-27ae-4496-a5df-18a7ddb50a17',
    args,
    throwError: true
  });
}

export const getCalculationAnalysisData = async (args) => {
  return getData({
    url: '/calculation/analysis/data',
    uuid: '51287f10-27ae-4496-a5df-18a7ddb50a17',
    args,
    throwError: true
  });
}

export const setCalculationDataMpep = async (args) => {
  return postData({
    url: '/calculation/analysis/load/mpep',
    uuid: '4ba79dd1-26d6-4523-90c4-b34cb026aa76',
    args,
    successNotify: true,
    loadPanel: true
  });
}

export const getUploadReport = async (args) => {
  return getData({
    url: '/calculation/upload/report',
    uuid: '33877907-6821-4f6d-ae51-154820975a33',
    args: {
      appId: getCookie('app'),
      ...args,
    },
    fullResponse: true
  });
};

export const getUploadReportGrouped = async (args) => {
  return getData({
    url: '/calculation/upload/report/grouped',
    uuid: 'ffd794e7-c7b6-4ef9-97d2-dd88b8cf75ba',
    args: {
      appId: getCookie('app'),
      ...args,
    },
    fullResponse: true
  });
};

export const getUploadReportDoubleSap = async (args) => {
  return getData({
    url: '/calculation/upload/report/double',
    uuid: '7cdd9fc6-e994-4ba4-b3c5-9da4f1dfcae8',
    args: {
      appId: getCookie('app'),
      ...args,
    },
    fullResponse: true
  });
};

export const getCalculationAnalysisReport = async (args) => {
  return getData({
    url: '/calculation/analysis/total/report',
    uuid: 'a915b55e-6b64-42d0-a51c-e6d13bc8d98c',
    args,
    loadPanel: true
  });
}

export const getCalculationAnalysisDetail = async (args) => {
  return getData({
    url: '/calculation/analysis/total/report/detail',
    uuid: '1b141a81-44c2-48fd-b476-adb92847db55',
    args,
    loadPanel: true
  });
}

export const getCalculationActivity = async (args) => {
  return getData({
    url: '/calculation/analysis/activity',
    uuid: 'ef0b98d6-b6b5-4835-939f-f6c548e7756f',
    args,
    dictionary: 'analysisActivity',
    loadPanel: true
  });
}

export const getCalculationArticleType = async (args) => {
  return getData({
    url: '/calculation/analysis/article/type',
    uuid: '5d7062da-6773-461b-bec0-fc34b5374d32',
    args,
    dictionary: 'articleType',
    loadPanel: true
  });
}

export const getCalculationArticle = async (args) => {
  return getData({
    url: '/calculation/analysis/article',
    uuid: '6fe4e23c-c084-4664-a55c-89867e654945',
    args
  });
}

export const getCalculationArticleDetail = async (args) => {
  return getData({
    url: '/calculation/analysis/article',
    uuid: '0627f5f5-8743-4305-99be-bbe6603a2b09',
    args,
    loadPanel: true
  });
}
